module.exports = "/assets/77921026756f9341f53b66f1ac347e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/QC.png
// module id = 2869
// module chunks = 0